import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from "@/components/icons";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'member';
  redirectTo?: string;
}

export function ProtectedRoute({ 
  children, 
  requiredRole = 'member', 
  redirectTo = '/auth/login' 
}: ProtectedRouteProps) {
  const { user, userRole, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  const hasPermission = () => {
    if (requiredRole === 'admin') {
      return userRole === 'admin';
    }
    if (requiredRole === 'member') {
      return userRole === 'admin' || userRole === 'member';
    }
    return true;
  };

  if (!hasPermission()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}